/* eslint-disable no-shadow */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { selectItems } from '@app/root-store/relationship-store/relationship.selector';
import { UserConnectionService } from '@app/shared/services/user_connection/user-connection.service';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'mutual-connection',
  templateUrl: './mutual-connection.component.html',
  styleUrl: './mutual-connection.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MutualConnectionComponent implements OnInit, OnDestroy {
  mutualUserlist: any[] | null = null;
  subscription = new Subscription();
  myRelationship$: Observable<any[]>;
  myRelationship: any = [];
  constructor(
    private _dialogRef: MatDialogRef<MutualConnectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private UserConnection: UserConnectionService,
    private cdr: ChangeDetectorRef,
    private store: Store
  ) {
    this.myRelationship$ = this.store.select(selectItems);
    this.subscription.add(
      this.myRelationship$.subscribe((data) => {
        this.myRelationship = data;
      })
    );
  }

  ngOnInit(): void {
    const user_id = this.data.id;
    this.subscription.add(
      this.UserConnection.getMutualConnections(user_id).subscribe((data) => {
        data.forEach((user: any) => {
          const matchedRelationship = this.myRelationship.find((rel: any) => rel.user_id === user.id);
          user.relationship_name = matchedRelationship ? matchedRelationship.relationship_name : null;
        });
        this.mutualUserlist = data;
        this.cdr.markForCheck(); // Trigger change detection
      })
    );
  }

  getMutualConnection() {
    const user_id = this.data.id;
    this.subscription.add(
      this.UserConnection.getMutualConnections(user_id).subscribe((data) => {
        data.forEach((user: any) => {
          const matchedRelationship = this.myRelationship.find((rel: any) => rel.user_id === user.id);
          user.relationship_name = matchedRelationship ? matchedRelationship.relationship_name : null;
        });
        this.mutualUserlist = data;
        this.cdr.markForCheck(); // Trigger change detection
      })
    );
  }

  closeDialog(): void {
    this._dialogRef.close();
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
